module.exports = "precision lowp float;\n\nuniform vec4 u_diffuse;\n\nFRAG_DEF_OUT\n\nvoid main() {\n\n  FRAG_OUT = vec4(u_diffuse);\n\n}\n"